import React from "react";

/**
 * Recharts Brush traveller with rounded corners, no outline stroke, and theme fill from `stroke` prop.
 */
export default function DashboardBrushTraveller(travellerProps) {
  const {
    x,
    y,
    width,
    height,
    stroke,
  } = travellerProps;
  const gripCenterY = Math.floor(y + height / 2) - 1;
  const cornerRadius = Math.min(5, height / 3);

  return (
    <g>
      <rect
        x={x}
        y={y}
        width={width}
        height={height}
        rx={cornerRadius}
        ry={cornerRadius}
        fill={stroke}
        stroke="none"
      />
      <line
        x1={x + 2}
        y1={gripCenterY}
        x2={x + width - 2}
        y2={gripCenterY}
        fill="none"
        stroke="#fff"
        strokeWidth={1}
      />
      <line
        x1={x + 2}
        y1={gripCenterY + 2}
        x2={x + width - 2}
        y2={gripCenterY + 2}
        fill="none"
        stroke="#fff"
        strokeWidth={1}
      />
    </g>
  );
}
